<template>
  <b-input-group>
    <v-select :style="inputStyte" v-model="localValue" :options="customerOptions" :reduce="opt => opt.id" @input="myChangeEvent" placeholder="Chọn khách hàng" :clearable="false"/>
    <b-input-group-append v-show="addBtn">
      <b-button v-if="size == 'sm'" :size="'sm'" :variant="'primary'" v-b-modal="modalId"><i class="fa fa-plus"/>
      </b-button>
      <b-button v-else :size="'sm'" :variant="'primary'" v-b-modal="modalId"><i class="fa fa-plus"/>Thêm</b-button>
    </b-input-group-append>
    <customer-creator-modal :id="modalId"/>
  </b-input-group>
</template>
<script>
import { mapGetters } from 'vuex'
import CustomerCreatorModal from './CustomerCreatorModal'

export default {
  name: 'CustomerSelect',
  components: { CustomerCreatorModal },
  props: {
    value: String,
    inputStyte: Object,
    size: String,
    addBtn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modalId: '',
      localValue: null
    }
  },
  mounted () {
    this.modalId = Math.floor(Math.random() * 1000000).toString()
    if (this.value) { this.localValue = this.value }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal) { this.localValue = newVal }
    }
  },
  computed: {
    ...mapGetters({
      'customerOptions': 'Customer/listOptionsState'
    })
  },
  methods: {
    myChangeEvent (event) {
      if (event) { this.$emit('input', event) }
    },
    mySelectEvent (event) {
      if (event) { this.$emit('input', event) }
    }
  }
}
</script>
